import { MediaApi } from '../../api/contentLibrary/models/content-library-media.api.model';
import { MediaModel } from '../../Common/ContentLibrary/models/content-library-media.model';

export interface MediaResultsModel {
    mediaResults?: MediaResultModel[];
}

export interface MediaMetadataResultsModel {
    mediaResults?: MediaApi[];
}

export interface MediaResultModel {
    codedError?: any;
    media?: MediaModel;
    metadata?: any;
}

export enum MediaServiceErrorCodesEnum {
    internalError = 'COM-008',
    fileMaxSize = 'COM-009',
    fileMinSize = 'COM-010',
    insufficientSpace = 'COM-011',
    invalidType = 'COM-012',
    duplicateFile = 'COM-003',
}
